// extracted by mini-css-extract-plugin
export default {"tabPanelContainer":"_tab-panel_tabPanelContainer__WKMQW","tabPanel":"_tab-panel_tabPanel__o1uP4","contactHeader":"_tab-panel_contactHeader__XJ3Yt"};